// extracted by mini-css-extract-plugin
export default {"counterText":"countUpFunction_counterText__JaJ+r"};